export default __webpack_public_path__ + "static/media/immune_system.b5f84b20.jpg";